import $ from 'jquery';
import 'slick-carousel';
import {forEach} from 'ramda';
import bindEvent from '../../scripts/util/bindEvent';
import addClass from '../../scripts/util/DOM/addClass';

// const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5),(min--moz-device-pixel-ratio: 1.5),(-o-min-device-pixel-ratio: 3/2),(min-resolution: 1.5dppx)';

// const isRetina = (window.devicePixelRatio > 1) || (window.matchMedia && window.matchMedia(mediaQuery).matches);

// const sliderImages = $('#slider-design').find('.stylish-design__image');

const selectors = {
	main: '#slider-design',
	arrow: '.stylish-design__arrow'
};

const classes = {
	fade: 'stylish-design__arrow_fade'
};

const addFadeClass = addClass(classes.fade);

const addAnimArrow = () => {
	const arrows = document.querySelectorAll(selectors.arrow);
	forEach(addFadeClass, arrows);

	setTimeout(() => {
		forEach(item => item.classList.remove(classes.fade), arrows);
	}, 500);
};

const render = () => {
	$(selectors.main).slick({
		prevArrow: '<div class= "stylish-design__arrow stylish-design__arrow_left"></div>',
		nextArrow: '<div class= "stylish-design__arrow stylish-design__arrow_right"></div>',
		infinite: true,
		dots: true,
		appendDots: '.js-design-dots',
		slidesToShow: 3,
		slidesToScroll: 1,
		centerMode: true,
		variableWidth: true,
		focusOnSelect: true,
		responsive: [
			{
				breakpoint: 325,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: false,
					focusOnSelect: false
				}
			}
		]
	});

	bindEvent(selectors.arrow, 'click', addAnimArrow);
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/stylish-design/stylish-design.js